import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-actions-directory',
  templateUrl: './actions-directory.component.html',
  styleUrls: ['./actions-directory.component.scss']
})
export class ActionsDirectoryComponent implements OnInit {
  @Input() directoryData;
  directoryForm: FormGroup;
  maxLength = 500;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.directoryForm = this.fb.group({
      charge: [(this.directoryData ? this.directoryData.charge : null), [Validators.required]],
      name: [(this.directoryData ? this.directoryData.name : null), [Validators.required]],
      description: [(this.directoryData ? this.directoryData.description : null), [Validators.required]],
      information: [(this.directoryData ? this.directoryData.information : null), [Validators.required]],
      orderId: [(this.directoryData ? this.directoryData.orderId : null), [Validators.required]]
    });
  }

  isValid(): void {
    const dataToSend: any = this.directoryForm.value;
    (this.directoryData && this.directoryData.id ? dataToSend.id = Number(this.directoryData['id']) : delete dataToSend.id);
    this.activeModal.close(dataToSend);
  }
}
